import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {SchoolModel} from '../../models/school/school.model';
import {AuthService} from '../auth.service';
import {map} from 'rxjs/operators';
import {GroupGradesSummary} from '../../models/school/group.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolAdminService {

  constructor(private authSv: AuthService) { }

  fetchSchool(schoolId: string): Observable<SchoolModel> {

    return this.authSv.get('/schools/' + schoolId).pipe(map((response) => {

      const school = SchoolModel.generate(response.data);
      return school;

    }));
  }

  fetchSchoolByLinkId(linkId: string): Observable<SchoolModel> {

    return this.authSv.get(`/schools/${linkId}/link`).pipe(map((response) => {

      const school = SchoolModel.generate(response.data);
      return school;

    }));

  }

  /**
   * Changes language for all students associated with the school
   */
  changeSchoolLanguage(culture: string, schoolId = SchoolModel.getCurrent()._id): Observable<SchoolModel> {

    return this.authSv.post(`/schools/${schoolId}/changeSchoolLanguage`, { culture }).pipe(map((response) => {

      const school = SchoolModel.generate(response.data);

      return school;

    }));

  }

  /**
   *
   */
  changeLocaleSettings(multiplicationSign: string,
                       divisionSign: string,
                       unitSystem: string,
                       schoolId = SchoolModel.getCurrent()._id): Observable<SchoolModel> {

    return this.authSv.patch(`/schools/${schoolId}/changeLocaleSettings`, {
      multiplicationSign,
      divisionSign,
      unitSystem
    }).pipe(map((response) => {

      const school = SchoolModel.generate(response.data);

      return school;

    }));

  }

  /**
   * Fetches the different grades this school has setup in their groups so we can
   * give reports based on actual grades used
   *
   * @param schoolId The school for which to check the grades
   */
  fetchGroupGradesSummary(schoolId: string = SchoolModel.getCurrent()._id): Observable<GroupGradesSummary> {

    return this.authSv.get(`/schools/${schoolId}/gradeSummary`).pipe(map((response) => {

      return GroupGradesSummary.generate(response.data);

    }))

  }

}
